import { MsgHandler } from './../../core/app/msg/msgHandler';
import * as consts from './../../core/app/common/consts';
import * as units from '../../core/app/common/units';
import { AppConfig } from '../../core/app/app.config';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import { SensorsCorePool } from '@core_n/asp/SensorsCorePool';
import { ObjectType } from '@core_n/asp/AspObject';
import { aspMngr } from '@core_n/asp/AspMngr';
import { SensorCoreObject } from '@core_n/asp/SensorCoreObject';


export class ErrNotificationsHandler extends MsgHandler {
  private static _self: ErrNotificationsHandler = null;
  private allErrorNotifications = new Array<any>();

  private constructor(private msgBoxService: MsgBoxService) {
    super(consts.MSG_TYPE_ERROR_NOTIFICATIONS);
    this.allErrorNotifications = JSON.parse(localStorage.getItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION));
    if (!this.allErrorNotifications)
      this.allErrorNotifications = new Array<any>();

    let alerts: any[] = [];
    const now = new Date().getTime();
    const hour = 60 * 60 * 1000; // in milis
    this.allErrorNotifications.forEach(element => {
      if (now - element.Date <= hour) {
        alerts.push(element);
      }
    });

    localStorage.removeItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION);
    localStorage.setItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION, JSON.stringify(alerts));
  }

  public static getSelf(msgBoxService: MsgBoxService): ErrNotificationsHandler {
    if (this._self == null)
      this._self = new ErrNotificationsHandler(msgBoxService);
    return this._self;
  }

  handleMsg(msgObj: any): void {
    if (AppConfig.settings.ShowLogs)
      console.log("err msg:", msgObj);

    // validating the message...
    if (msgObj.StreamName == undefined) {
      console.error("alert msg missing StreamName Field")
      return;
    }
    if (msgObj.Type == undefined)
      msgObj.Type = "NONE"
    if (msgObj.Message == undefined)
      msgObj.Message = "NONE"

    let date: Date = new Date();
    if (msgObj.EventDate == undefined)
      msgObj.EventDate = (Date.now());
    else
      date = new Date(msgObj.EventDate);

    msgObj.StringTime = new Date(msgObj.EventDate).toLocaleString('en-GB', {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const millis = String(date.getMilliseconds()).padStart(3,'0');

    msgObj.StringTime = `${msgObj.StringTime}.${millis}`;
    let camera: SensorCoreObject;
    try {
      camera = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((msgObj.StreamName as string).toLowerCase());
    }
    catch (e) {
      camera = undefined;
    }
    if (!camera) {
      try {
        camera = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get((msgObj.StreamName as string).toLowerCase() + ".stream");
      }
      catch (e) {
        console.log(e);
        console.error("alert msg Dismissed due to related sensor not found in the system...");
        return;
      }
    }

    msgObj.CameraName = camera.name;

    this.handleErrorNotifications(msgObj);
    this.handleMessageToBanner(msgObj)
  }

  handleErrorNotifications(msgObj) {
    let isNewNotification = JSON.parse(localStorage.getItem(consts.LOCAL_STORAGE_NEW_ERR_NOTIFICATION));
    if (isNewNotification == false) {
      this.allErrorNotifications.map(u => u.isNew == true ? u.isNew = false : u.isNew = false);
    }
    msgObj.Date = new Date().getTime();
    msgObj.isNew = true;
    this.allErrorNotifications.unshift(msgObj);
    if (this.allErrorNotifications.length > 200) {
      this.allErrorNotifications.splice(this.allErrorNotifications.length - 1, 1);
    }
    localStorage.setItem(consts.LOCAL_STORAGE_ALL_ERR_NOTIFICATION, JSON.stringify(this.allErrorNotifications));
    localStorage.setItem(consts.LOCAL_STORAGE_NEW_ERR_NOTIFICATION, JSON.stringify(true));
  }

  handleMessageToBanner(msgObj: any) {
    this.msgBoxService.showAlert(msgObj);
  }
}
